import React, { Component, useRef } from 'react';
import classNames from 'classnames';
import {withRouter } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { Dialog } from 'primereact/dialog';
import { LanguageService } from './service/LanguageService';
import { ProgressBar } from 'primereact/progressbar';
import { Message } from 'primereact/message';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { AuthorizationService } from './service/AuthorizationService';
import ADB2CLogout from './components/adb2c/ADB2CLogout';

class AppProfile extends Component {

    constructor() {
        super();
        this.state = {
            expanded: false,
            showLanguageModal: false,
            showProfileModal: false
        };
        this.onClick = this.onClick.bind(this);
        this.languageService = new LanguageService();
        this.authorizationService = new AuthorizationService();
    }

    onClick(event) {
        this.setState({ expanded: !this.state.expanded });
        event.preventDefault();
    }

    setLanguage(lang){
        this.languageService.setLanguage(lang);
        window.location.reload();
    }

    async updatePassword(){
        const { currentPassword, password, passwordConfirmation } = this.state;
        try {
            if(password !== passwordConfirmation){
                await this.setState({processing: false, processFailed: true, failReason: this.languageService.getText("Different_Passowrds")});
            }
            else {
                await this.setState({processing: true, processFailed: false});
                const user = await this.authorizationService.updatePassword(currentPassword, password);
                await this.setState({processing: false, processFinished: true, showUpdatePasswordModal: false, password: '', currentPassword: '', passwordConfirmation: ''});
            }
        } catch (error) {
            console.log(error);
            let failReason = error.toString();
            if(failReason === "Invalid credentials"){
                failReason = this.languageService.getText("Incorrect_Current_Password");
            }
            await this.setState({processing: false, processFailed: true, failReason});
        }
    }

    logout(){
        const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
        localStorage.removeItem("loggedInUser");
        localStorage.removeItem("AuthorizationToken");
        if(loggedInUser.client && !loggedInUser.client.use_custom_url){
            this.props.history.push('/' + loggedInUser.client.shortcode);
        }
        else{
            this.props.history.push('/');
        }
        
        window.location.reload();
    }   

    render() {
        const { processing, processFailed, failReason } = this.state;
        const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
        const client = loggedInUser.client;
        
        return (
            <div className="layout-profile" style={{marginTop: '20px'}}>
                <button className="p-link layout-profile-link" onClick={() => this.setState({showProfileModal: true})}>
                    <i className="pi pi-fw pi-user" style={{marginRight: '10px'}}/>
                    <span className="username" style={{marginTop: '20px'}}>{ loggedInUser.name }</span>
                </button>
                { this.state.showProfileModal &&
                <Dialog 
                    style={{ width: '50vw' }} 
                    visible={true} 
                    header={"Dados Pessoais"} modal onHide={() => this.setState({showProfileModal: false})}
                    footer={
                        client && (client.config.authenticationType || "local") === "ADB2C" ?
                            <ADB2CLogout onLogout={this.logout}/>
                        :

                        <React.Fragment>
                            <Button label={this.languageService.getText("Update_Password")} icon="pi pi-key" className="p-button-text" onClick={() => this.setState({ showUpdatePasswordModal: true})} />
                            <Button label={this.languageService.getText("Logout")} icon="pi pi-power-off" className="p-button-text" onClick={() => this.logout()} />
                        </React.Fragment>
                    }
                    >
                    <div className="p-grid">
                        <div className="p-col-6">
                            <b>Nome</b><br/>
                            { loggedInUser.name }
                        </div>
                        <div className="p-col-6">
                            <b>Email</b><br/>
                            { loggedInUser.email }
                        </div>
                        { client && client.signup_config && client.signup_config.extraFields && <>
                            { client.signup_config.extraFields.map(f =>
                                <div className="p-col-6">
                                    <b>{f.label}</b><br/>
                                    { loggedInUser.extra_fields[f.id] }
                                </div>
                            )}
                        </>}
                    </div>
                </Dialog>
                }
                { this.state.showLanguageModal &&
                <Dialog style={{ width: '300px' }} visible={true} header={this.languageService.getText("Select_Language")} modal onHide={() => this.setState({showLanguageModal: false})}>
                    <div className="confirmation-content">
                        <table>
                            <tr>
                                <td><img src={`assets/layout/images/pt-BR.png`} style={{height:'11px', width: '16px' }}/></td>
                                <td align="left"><button className="p-link" onClick={() => this.setLanguage('pt-BR')}>{this.languageService.getText("Portuguese")}</button></td>
                            </tr>
                            <tr>
                                <td><img src={`assets/layout/images/en-US.png`} style={{height:'11px', width: '16px' }}/></td>
                                <td align="left"><button className="p-link" onClick={() => this.setLanguage('en-US')}>{this.languageService.getText("English")}</button></td>
                            </tr>
                        </table>                        
                    </div>
                </Dialog>
                }
                { this.state.showUpdatePasswordModal &&
                <Dialog style={{ width: '300px' }} visible={true} modal onHide={() => this.setState({showUpdatePasswordModal: false})}>
                    <div className="p-grid" style={{backgroundColor: '#FFFFFF'}}>
                    <div className="p-col-12" style={{textAlign: 'left'}}><b>{this.languageService.getText("Current_Password")}</b></div>
                        <div className="p-col-12"><Password disabled={processing} feedback={false} value={this.state.currentPassword || ""} onChange={(e) => this.setState({currentPassword: e.target.value})} style={{width: '100%'}}/></div>
                        <div className="p-col-12" style={{textAlign: 'left'}}><b>{this.languageService.getText("New_Password")}</b></div>
                        <div className="p-col-12"><Password disabled={processing} feedback={false} value={this.state.password || ""} onChange={(e) => this.setState({password: e.target.value})} style={{width: '100%'}}/></div>
                        <div className="p-col-12" style={{textAlign: 'left'}}><b>{this.languageService.getText("Confirm_Password")}</b></div>
                        <div className="p-col-12"><Password disabled={processing} feedback={false} value={this.state.passwordConfirmation || ""} onChange={(e) => this.setState({passwordConfirmation: e.target.value})} style={{width: '100%'}}/></div>
                        <div className="p-col-12" style={{textAlign: 'center'}}>
                            <Button 
                                disabled={!this.state.passwordConfirmation || !this.state.password || this.state.passwordConfirmation === "" || this.state.password === "" || processing === ""} 
                                label={this.languageService.getText("Update_Password")}
                                onClick={() => this.updatePassword()}
                                style={{backgroundColor: client ? client.custom_layout.primaryButtonColor || '' : '', borderColor: client ? client.custom_layout.primaryButtonColor || '' : ''}}                              
                            />
                            { processing && <div style={{marginTop: '10px'}}><ProgressBar mode="indeterminate"/></div> }
                            { processFailed && <Message severity="error" text={failReason} closable={false} style={{marginLeft: '10px'}}/>}
                        </div>
                    </div>
                </Dialog>
                }
            </div>
        );
    }
}

export default withRouter(AppProfile);